// extracted by mini-css-extract-plugin
module.exports = {"richText":"ProjectSectionRichText_richText__r2ktf"};